export default function CancellationOrderDetails({ line_items = [] }) {
    return (
        <div className="table-cell px-5 py-3 align-top">
            <div className="min-w-[280px] max-w-[420px] text-sm">
                <ul className="space-y-1 text-gray-700">
                    {line_items.map((item) => (
                        <li key={item.id} className="flex gap-2 leading-5">
                            <span className="shrink-0 tabular-nums">{item.fulfillable_quantity} ×</span>
                            <span
                                className="min-w-0 truncate"
                                title={item.title || item.name || item.sku || 'Article sans libellé'}
                            >
                                {item.title || item.name || item.sku || 'Article sans libellé'}
                            </span>
                        </li>
                    ))}
                </ul>
                {!line_items.length && <p className="text-gray-500">Aucun article restant à expédier</p>}

            </div>
        </div>
    )
}
